import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import AgenticAIDosReportTabDetails from "./AgenticAIDosReportTabDetails";
import AgenticAIDosReportTabRecommendations from "./AgenticAIDosReportTabRecommendations";


const AgenticAIDosReportTab = ({ reportData }) => {
  const { t } = useTranslation("reports_recs", { keyPrefix: "reports_common" });
  const [selectedSubTab, setSelectedSubTab] = useState("details");
  
  // Sub-tab categories
  const subTabs = [
    { id: "details", label: t("agenticAiDosReportDetails"), color: "#3b82f6" },
    { id: "recommendations", label: t("agenticAiDosRecommendations"), color: "#3b82f6" }
  ];

  const getSubTabButtonStyle = (tab) => {
    const isSelected = selectedSubTab === tab.id;
    return {
      padding: "12px 20px",
      background: isSelected
        ? "linear-gradient(135deg, #3b82f6, #1d4ed8)"
        : "var(--card-bg)",
      color: isSelected ? "white" : "var(--body-text)",
      border: isSelected
        ? "2px solid #3b82f6"
        : "2px solid var(--card-border)",
      borderRadius: "8px",
      cursor: "pointer",
      fontSize: "14px",
      fontWeight: "500",
      transition: "all 0.3s ease",
      display: "flex",
      alignItems: "center",
      gap: "8px",
      boxShadow: isSelected
        ? "0 4px 12px rgba(59, 130, 246, 0.3)"
        : "0 2px 4px rgba(0, 0, 0, 0.1)",
      minWidth: "150px",
      justifyContent: "center"
    };
  };

  // Extract dos_simulation from score_json (where it's actually stored)
  const scoreJson = reportData?.score_json || {};
  const dosData = scoreJson?.dos_simulation;

  // Check if key exists in score_json
  const keyExists = scoreJson && typeof scoreJson === 'object' && 'dos_simulation' in scoreJson;

  // Check if dosData is empty object (no keys or all falsy)
  const isEmptyObject = !dosData || 
    (typeof dosData === 'object' && 
     !Array.isArray(dosData) && 
     Object.keys(dosData).length === 0);

  // Validate data structure - check if it matches sample JSON structure
  // Required keys at root level: summary, attack_type_breakdown, detailed_results
  const hasExpectedStructure = dosData &&
    typeof dosData === 'object' &&
    !Array.isArray(dosData) &&
    // Check that all required keys exist at root level
    dosData.summary &&
    dosData.attack_type_breakdown &&
    dosData.detailed_results;

  return (
    <div style={{ padding: "20px" }}>
      {/* Sub-tab Button Selectors */}
      <div style={{ marginBottom: "24px", marginTop: "10px" }}>
        <div style={{
          display: "flex",
          flexWrap: "wrap",
          gap: "12px"
        }}>
          {subTabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => setSelectedSubTab(tab.id)}
              style={getSubTabButtonStyle(tab)}
            >
              <span>{tab.label}</span>
            </button>
          ))}
        </div>
      </div>

      {/* Tab Content */}
      {selectedSubTab === "details" && (
        <AgenticAIDosReportTabDetails 
          dosData={dosData}
          keyExists={keyExists}
          isEmptyObject={isEmptyObject}
          hasExpectedStructure={hasExpectedStructure}
        />
      )}
      {selectedSubTab === "recommendations" && (
        <AgenticAIDosReportTabRecommendations
          reportData={reportData}
        />
      )}
    </div>
  );
};

export default AgenticAIDosReportTab;
